import React, { useState } from "react";
import { SidebarCloseIcon } from "../../Icons";
import Simulation from "./Simulation";
import ConstructionStatus from "./ConstructionStatus";

export default function FdBottomDrawer({
  setIsShowDrawer,
  setIsOpenSearchResult,
}) {
  const [activeTab, setActiveTab] = useState("4D 시뮬레이션");
  return (
    <div className="bg-[#F0F0F0] max-h-full">
      {/* header  */}
      <div className="bg-white py-[5px] pl-4 md:pl-5 pr-2 md:pr-2.5 flex items-center justify-between gap-4 relative z-[1]">
        <h6 className="text-[#242424] text-[12px] font-bold">4D</h6>
        <button onClick={() => setIsShowDrawer(false)}>
          <SidebarCloseIcon color="#242424" />
        </button>
      </div>

      {/* tab btn  */}
      <div className="grid grid-cols-2 p-2.5 gap-2 border-b border-[#C9C9C9]/30">
        {["4D 시뮬레이션", "실시간 시공 현황"].map((it, idx) => (
          <button
            key={idx}
            className={`p-1 rounded-[4px] text-[12px] font-bold transition-all ease-linear duration-300 ${
              activeTab === it
                ? "bg-white text-[#242424]"
                : "bg-[#E6E6E6] text-[#797979]"
            }`}
            onClick={() => setActiveTab(it)}
          >
            {it}
          </button>
        ))}
      </div>
      {activeTab === "4D 시뮬레이션" ? (
        <Simulation setIsOpenSearchResult={setIsOpenSearchResult} />
      ) : (
        <ConstructionStatus />
      )}
    </div>
  );
}
